<div class="help-content">
  <h1>Guided Tours</h1>

  <p>
    Explore Semeris Docs with guided tours of our key features. As you progress through the tours, you can see here which sections you've
    completed.
  </p>

  @if (completedGuideTours$ | async; as completedGuideTours) {
    <h2>Getting started</h2>
    <ul>
      <li>
        <semeris-progress-indicator
          [completed]="!!completedGuideTours['dashboard']"
          [fastTooltip]="completedGuideTours['dashboard'] ? 'You have completed this tour.' : null"
        ></semeris-progress-indicator>
        <a routerLink="/home" [queryParams]="{ guidedTourId: 'dashboard' }">Getting Started</a>
      </li>
      @if (guidedTourParamsExtended()?.dealFilterId; as id) {
        <li>
          <semeris-progress-indicator
            [completed]="!!completedGuideTours['deal-filter']"
            [fastTooltip]="completedGuideTours['deal-filter'] ? 'You have completed this tour.' : null"
          ></semeris-progress-indicator>
          <a
            [routerLink]="['/', SemerisRoutes.dealFilter.root, SemerisRoutes.dealFilter.filter, id]"
            [queryParams]="{ guidedTourId: 'deal-filter' }"
            >Finding Deals</a
          >
        </li>
      }
      @if (guidedTourParamsExtended()?.transaction; as transaction) {
        <li>
          <semeris-progress-indicator
            [completed]="!!completedGuideTours['deal-page']"
            [fastTooltip]="completedGuideTours['deal-page'] ? 'You have completed this tour.' : null"
          ></semeris-progress-indicator>
          <a [routerLink]="transaction | transactionToLink" [queryParams]="{ guidedTourId: 'deal-page', panels: 'summary,document' }"
            >Working with Deals</a
          >
        </li>
      }
    </ul>
    @if (guidedTourParamsExtended()?.transaction) {
      <h2>Reviewing documents</h2>
    }
    <ul>
      @if (guidedTourParamsExtended()?.transaction; as transaction) {
        <li>
          <semeris-progress-indicator
            [completed]="!!completedGuideTours['viewer-guide']"
            [fastTooltip]="completedGuideTours['viewer-guide'] ? 'You have completed this tour.' : null"
          ></semeris-progress-indicator>
          <a
            [routerLink]="transaction | transactionToLink"
            [queryParams]="{ panels: 'document', guidedTourId: 'viewer-guide' }"
            (click)="startGuidedTourInViewer('viewer-navigation')"
            >Reviewing Documents</a
          >
        </li>
      }
      <ng-container *permissions="[Permissions.READ_TERM_EXPLORER]">
        @if (guidedTourParamsExtended()?.transaction; as transaction) {
          <li>
            <semeris-progress-indicator
              [completed]="!!completedGuideTours['term-explorer']"
              [fastTooltip]="completedGuideTours['term-explorer'] ? 'You have completed this tour.' : null"
            ></semeris-progress-indicator>
            <a
              [routerLink]="transaction | transactionToLink"
              [queryParams]="{ guidedTourId: 'term-explorer', panels: 'termExplorer,document' }"
              >Using the Term Explorer</a
            >
          </li>
        }
      </ng-container>
    </ul>
    @if ((guidedTourParamsExtended()?.dealFilterId && guidedTourParamsExtended()?.topicId) || guidedTourParamsExtended()?.searchPhrase) {
      <h2>Researching the market</h2>
    }
    <ul>
      @if (guidedTourParamsExtended()?.dealFilterId && guidedTourParamsExtended()?.topicId) {
        <li>
          <semeris-progress-indicator
            [completed]="!!completedGuideTours['market-compare']"
            [fastTooltip]="completedGuideTours['market-compare'] ? 'You have completed this tour.' : null"
          ></semeris-progress-indicator>
          <a
            [routerLink]="['/', SemerisRoutes.marketComparison.root, guidedTourParamsExtended().topicId]"
            [queryParams]="{ guidedTourId: 'market-compare', dealFilterId: guidedTourParamsExtended().dealFilterId }"
            >Comparing deals to market</a
          >
        </li>
      }
      <ng-container *permissions="[Permissions.READ_TEXT_SEARCH]">
        @if (guidedTourParamsExtended()?.searchPhrase; as phrase) {
          <li>
            <semeris-progress-indicator
              [completed]="!!completedGuideTours['text-search']"
              [fastTooltip]="completedGuideTours['text-search'] ? 'You have completed this tour.' : null"
            ></semeris-progress-indicator>
            <a [routerLink]="['/', SemerisRoutes.search.documentSearch]" [queryParams]="{ guidedTourId: 'text-search', q: phrase }"
              >Using the search engine
            </a>
          </li>
        }
      </ng-container>
    </ul>
    <ng-container *permissions="[Permissions.WRITE_COMMENT]">
      <h2>Taking Notes</h2>
      <ul>
        <li>
          <semeris-progress-indicator
            [completed]="!!completedGuideTours['note-block']"
            [fastTooltip]="completedGuideTours['note-block'] ? 'You have completed this tour.' : null"
          ></semeris-progress-indicator>
          <a [routerLink]="['/', SemerisRoutes.notes]" [queryParams]="{ guidedTourId: 'note-block' }">Overview</a>
        </li>
        <li>
          <semeris-progress-indicator
            [completed]="!!completedGuideTours['note-actions']"
            [fastTooltip]="completedGuideTours['note-actions'] ? 'You have completed this tour.' : null"
          ></semeris-progress-indicator>
          <a [routerLink]="['/', SemerisRoutes.notes]" [queryParams]="{ guidedTourId: 'note-actions', forcedHover: true }"
            >Working with a note</a
          >
        </li>
        <li>
          <semeris-progress-indicator
            [completed]="!!completedGuideTours['notes-page']"
            [fastTooltip]="completedGuideTours['notes-page'] ? 'You have completed this tour.' : null"
          ></semeris-progress-indicator>
          <a [routerLink]="['/', SemerisRoutes.notes]" [queryParams]="{ guidedTourId: 'notes-page' }">Reviewing and exporting notes</a>
        </li>
      </ul>
    </ng-container>
  }
  <br /><br />
  <p><i>Have questions? Our support team is here to help.</i></p>
</div>
